import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ProviderClientStatusHistoryModel extends BaseModel {
  static urlPath = "provider-client-status-history";

  @attr("json") createdAt;
  @attr("json") updatedAt;
  @attr("json") createdBy;
  @attr("json") updatedBy;
  @attr("json") client;
  @attr("json") provider;
  @attr("json") medicalDocumentsStatus;
  @attr("json") finishedTreatment;
  @attr("json") currentBalance;
  @attr("json") medicalRecordNumber;
  @attr("json") estimatedAppointmentCount;
  @attr("json") confirmedBalance;
  @attr("json") confirmedBalanceChangedBy;
  @attr("json") confirmedBalanceChanged;
  @attr("json") runningTotalChangedBy;
  @attr("json") runningTotalChanged;
  @attr("json") runningTotal;
  @attr("json") outOfNetworkJustification;
}
